module.exports = __webpack_public_path__ + "img/yellow.d1735fdc.jpg";